<template>
	<div class="bg-light p-3">
		<span>{{ $loc.fromResource('com.table.report.progressing') }}</span>
		<div class="progress rounded-0 mt-2 mb-1">
			<div class="progress-bar progress-bar-animated" v-bind:style="{'width' : percent}">
			</div>
		</div>
		<table class="table table-light mt-4">
			<tbody>
				<tr>
					<td style="width:250px;">درصد پیشرفت</td>
					<td>{{ value }} درصد</td>
				</tr>
				<tr>
					<td>زمان حدودی باقیمانده تا پایان عملیات</td>
					<td>{{ remainingTasksTime }}</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>
<script>
	export default {
		props: {
			'totalPartLength': {
				type: Number,
				default: 0
			},

			'currentPartLength': {
				type: Number,
				default: 0
			},

			'duration': {
				type: Number,
				default: 0
			},
		},

		computed:
		{
			remainingTasksTime()
			{
				var duration =
					this.duration;

				var milliseconds = parseInt((duration % 1000) / 100),
					seconds = Math.floor((duration / 1000) % 60),
					minutes = Math.floor((duration / (1000 * 60)) % 60),
					hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

				hours = (hours < 10) ? "0" + hours : hours;
				minutes = (minutes < 10) ? "0" + minutes : minutes;
				seconds = (seconds < 10) ? "0" + seconds : seconds;

				return hours + ":" + minutes + ":" + seconds;
			},

			value()
			{
				return Math.round((100 / this.totalPartLength) * this.currentPartLength)
			},

			percent()
			{
				return this.value + '%'
			},
		}
	}
</script>
